

function FlexCenter({ children }) {
  return (
    <div className='d-flex justify-content-center'>
        { children }
    </div>
  )
}

export default FlexCenter
